// Main JS entry point: mobile menu, accordions, and accessible nav behavior
(function () {
  if (typeof document === "undefined") return;

  // Diagnostic: log clicks on any anchor that contains a hash so we can see
  // whether the user is actually clicking a fragment link (e.g. /genetics#cause)
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a");
    if (!a) return;
    var href = a.getAttribute && a.getAttribute("href");
    if (!href) return;
    if (href.indexOf("#") !== -1) {
      console.log(
        "Anchor clicked with hash:",
        href,
        "text:",
        (a.textContent || "").trim(),
      );
    }
  });

  // Diagnostic: log referrer and initial scroll position when page loads
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      console.log(
        "page load: location=",
        window.location.href,
        "referrer=",
        document.referrer,
        "initialScrollY=",
        window.scrollY,
      );
    });
  } else {
    console.log(
      "page load: location=",
      window.location.href,
      "referrer=",
      document.referrer,
      "initialScrollY=",
      window.scrollY,
    );
  }

  var body = document.body;
  var mobileToggle = document.getElementById("mobile-menu-toggle");
  var mobileMenu = document.getElementById("mobile-menu");
  var mobileClose = mobileMenu
    ? mobileMenu.querySelector(".mobile-close")
    : null;
  var docEl = document.documentElement;

  function setMobileMenuTopFromNav() {
    try {
      // Prefer positioning the dropdown at the top of the FDA banner content
      var fdaContent = document.querySelector(".fda-banner__content");
      if (fdaContent) {
        var fcRect = fdaContent.getBoundingClientRect();
        var fcTop = fcRect.top; // viewport-relative for fixed positioning
        docEl.style.setProperty("--mobile-menu-top", fcTop + "px");
        return;
      }

      // Fallback: use the overall banner if content element is not found
      var fda = document.querySelector(".fda-banner");
      if (fda) {
        var fdaRect = fda.getBoundingClientRect();
        var fdaTop = fdaRect.top;
        docEl.style.setProperty("--mobile-menu-top", fdaTop + "px");
        return;
      }

      // Fallback: align right under the main nav row
      var nav = document.querySelector(".nav-main-row");
      if (nav) {
        var rect = nav.getBoundingClientRect();
        // Use viewport-relative bottom edge of nav for fixed top
        var top = rect.bottom;
        docEl.style.setProperty("--mobile-menu-top", top + "px");
      }
    } catch (e) {
      // no-op if fails
    }
  }

  function openMobileMenu() {
    if (!mobileMenu) return;
    setMobileMenuTopFromNav();
    mobileMenu.setAttribute("aria-hidden", "false");
    if (mobileToggle) mobileToggle.setAttribute("aria-expanded", "true");
    body.classList.add("mobile-menu-open");
    if (mobileToggle) mobileToggle.classList.add("open");
    // trap focus if possible
    var inner = mobileMenu.querySelector(".mobile-menu-inner");
    if (inner && inner.focus) inner.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.setAttribute("aria-hidden", "true");
    mobileToggle.setAttribute("aria-expanded", "false");
    body.classList.remove("mobile-menu-open");
    mobileToggle.classList.remove("open");
    mobileToggle.focus();
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", function (e) {
      // Recompute position on each toggle
      setMobileMenuTopFromNav();
      var isOpen = mobileMenu.getAttribute("aria-hidden") === "false";
      if (isOpen) closeMobileMenu();
      else openMobileMenu();
    });
  }

  if (mobileClose) {
    mobileClose.addEventListener("click", closeMobileMenu);
  }

  // Close when clicking the overlay (i.e., the mobile-menu element but outside the inner)
  if (mobileMenu) {
    mobileMenu.addEventListener("click", function (e) {
      var inner = mobileMenu.querySelector(".mobile-menu-inner");
      if (inner && !inner.contains(e.target)) {
        closeMobileMenu();
      }
    });
  }

  // Close on ESC
  document.addEventListener("keydown", function (e) {
    if (
      e.key === "Escape" &&
      mobileMenu &&
      mobileMenu.getAttribute("aria-hidden") === "false"
    ) {
      closeMobileMenu();
    }
  });

  // Update variable on resize/scroll to keep overlay pinned below nav
  window.addEventListener("resize", setMobileMenuTopFromNav);
  window.addEventListener("scroll", function () {
    // only update when menu is open to reduce churn
    if (mobileMenu && mobileMenu.getAttribute("aria-hidden") === "false") {
      setMobileMenuTopFromNav();
    }
  });

  // Mobile accordion behavior
  document.addEventListener("click", function (e) {
    // Check if click was on the accordion label - if so, navigate to the page
    var label = e.target.closest && e.target.closest(".mobile-accordion-label");
    if (label) {
      var acc = label.closest(".mobile-accordion");
      if (acc) {
        var url = acc.getAttribute("data-url");
        if (url) {
          window.location.href = url;
          return; // Don't toggle accordion
        }
      }
    }

    // Otherwise, handle normal accordion toggle behavior
    var acc = e.target.closest && e.target.closest(".mobile-accordion");
    if (acc) {
      var expanded = acc.getAttribute("aria-expanded") === "true";
      // Toggle aria-expanded and open class
      acc.setAttribute("aria-expanded", expanded ? "false" : "true");
      acc.classList.toggle("open", !expanded);
      var parent = acc.parentNode;
      if (parent) {
        parent.classList.toggle("open", !expanded);
        // Show/hide submenu if present
        var submenu = parent.querySelector(".mobile-submenu");
        if (submenu) {
          submenu.hidden = expanded; // when expanded=false -> show (hidden=false)
        }
      }
    }
  });

  // Desktop: parent dropdown labels are hover-only; block click navigation/focus.
  document.addEventListener("mousedown", function (e) {
    var parentAnchor =
      e.target.closest &&
      e.target.closest(
        "#masthead .global-menu .menu-item.has-children > a[aria-haspopup='true']",
      );
    if (parentAnchor) {
      e.preventDefault();
    }
  });

  document.addEventListener("click", function (e) {
    var parentAnchor =
      e.target.closest &&
      e.target.closest(
        "#masthead .global-menu .menu-item.has-children > a[aria-haspopup='true']",
      );
    if (parentAnchor) {
      e.preventDefault();
      return;
    }

    if (e.target.closest && e.target.closest(".chev-toggle")) {
      e.preventDefault();
    }
  });

  function closeMastheadDesktopDropdown(li) {
    if (!li || !li.classList.contains("has-children")) return;
    var anchor = li.querySelector("a[aria-expanded]");
    if (anchor) {
      anchor.setAttribute("aria-expanded", "false");
      anchor.blur();
    }
  }

  function closeOtherMastheadDesktopDropdowns(exceptLi) {
    var items = document.querySelectorAll(
      "#masthead .global-menu .menu-item.has-children",
    );
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== exceptLi) {
        closeMastheadDesktopDropdown(items[i]);
      }
    }
  }

  function initMastheadDesktopDropdownClose() {
    var items = document.querySelectorAll(
      "#masthead .global-menu .menu-item.has-children",
    );
    for (var i = 0; i < items.length; i++) {
      (function (li) {
        li.addEventListener("mouseenter", function () {
          closeOtherMastheadDesktopDropdowns(li);
        });
        li.addEventListener("mouseleave", function () {
          closeMastheadDesktopDropdown(li);
        });
        li.addEventListener("focusout", function (e) {
          if (!li.contains(e.relatedTarget)) {
            closeMastheadDesktopDropdown(li);
          }
        });
      })(items[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMastheadDesktopDropdownClose);
  } else {
    initMastheadDesktopDropdownClose();
  }
})();

// Accessible accordion behavior for page-impact accordions
(function () {
  if (typeof document === "undefined") return;
  var accRoot = document.querySelector(".accordion");
  if (!accRoot) return;

  var items = Array.prototype.slice.call(
    accRoot.querySelectorAll(".accordion-item"),
  );
  var headers = items.map(function (it) {
    return it.querySelector(".accordion-header");
  });

  function closePanel(item) {
    var h = item.querySelector(".accordion-header");
    var p = item.querySelector(".accordion-panel");
    if (h && p) {
      h.setAttribute("aria-expanded", "false");
      p.hidden = true;
      p.setAttribute("aria-hidden", "true");
      var icon = h.querySelector(".accordion-icon");
      if (icon) icon.textContent = "+";
      item.classList.remove("open");
    }
  }

  function openPanel(item) {
    var h = item.querySelector(".accordion-header");
    var p = item.querySelector(".accordion-panel");
    if (h && p) {
      h.setAttribute("aria-expanded", "true");
      p.hidden = false;
      p.setAttribute("aria-hidden", "false");
      var icon = h.querySelector(".accordion-icon");
      if (icon) icon.textContent = "\u2212";
      item.classList.add("open");
    }
  }

  headers.forEach(function (h, idx) {
    if (!h) return;
    // make whole header clickable
    h.addEventListener("click", function (e) {
      var expanded = h.getAttribute("aria-expanded") === "true";
      if (expanded) closePanel(items[idx]);
      else openPanel(items[idx]);
    });

    // keyboard support
    h.addEventListener("keydown", function (e) {
      // Toggle on Enter or Space
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        h.click();
        return;
      }
      // Move focus
      if (e.key === "ArrowDown") {
        e.preventDefault();
        var next = headers[(idx + 1) % headers.length];
        if (next) next.focus();
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        var prev = headers[(idx - 1 + headers.length) % headers.length];
        if (prev) prev.focus();
        return;
      }
      if (e.key === "Home") {
        e.preventDefault();
        if (headers[0]) headers[0].focus();
        return;
      }
      if (e.key === "End") {
        e.preventDefault();
        if (headers[headers.length - 1]) headers[headers.length - 1].focus();
        return;
      }
    });
  });

  // start all closed
  items.forEach(function (it) {
    closePanel(it);
  });
})();

// Tabbed content behavior: accessible tabs (click + keyboard)
(function () {
  if (typeof document === "undefined") return;
  var tabContainers = document.querySelectorAll(".tabbed-content");
  if (!tabContainers || !tabContainers.length) return;

  tabContainers.forEach(function (container) {
    var tabs = Array.prototype.slice.call(
      container.querySelectorAll('[role="tab"]'),
    );
    var panels = Array.prototype.slice.call(
      container.querySelectorAll('[role="tabpanel"]'),
    );
    if (!tabs.length || !panels.length) return;

    function activateTab(tab) {
      tabs.forEach(function (t) {
        var sel = t === tab;
        t.setAttribute("aria-selected", sel ? "true" : "false");
        t.tabIndex = sel ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute("aria-labelledby") !== tab.id;
      });
      tab.focus();
    }

    // click
    tabs.forEach(function (t) {
      t.addEventListener("click", function (e) {
        activateTab(t);
      });

      t.addEventListener("keydown", function (e) {
        var idx = tabs.indexOf(t);
        if (e.key === "ArrowRight" || e.key === "Right") {
          e.preventDefault();
          var next = tabs[(idx + 1) % tabs.length];
          activateTab(next);
        }
        if (e.key === "ArrowLeft" || e.key === "Left") {
          e.preventDefault();
          var prev = tabs[(idx - 1 + tabs.length) % tabs.length];
          activateTab(prev);
        }
        if (e.key === "Home") {
          e.preventDefault();
          activateTab(tabs[0]);
        }
        if (e.key === "End") {
          e.preventDefault();
          activateTab(tabs[tabs.length - 1]);
        }
      });
    });

    // ensure initial state
    var initial =
      tabs.find(function (t) {
        return t.getAttribute("aria-selected") === "true";
      }) || tabs[0];
    activateTab(initial);
  });
})();

// Exit link modal functionality
(function () {
  if (typeof document === "undefined") return;

  var exitModal = document.getElementById("exit-modal");
  var confirmBtn = document.getElementById("Leave_Site");
  var cancelBtn = document.getElementById("Cancel_Leaving_Site");
  var currentExitLink = null;

  // Function to show exit modal
  function showExitModal(targetUrl) {
    if (!exitModal) return;

    currentExitLink = targetUrl;

    // Don't set href - we'll use window.open() instead to prevent double navigation
    exitModal.showModal();
  }

  // Function to hide exit modal
  function hideExitModal() {
    if (!exitModal) return;
    exitModal.close();
    currentExitLink = null;
  }

  // Handle clicks on exit-link elements
  document.addEventListener("click", function (e) {
    var exitLink = e.target.closest(".exit-link");
    if (!exitLink) return;

    e.preventDefault(); // Prevent default link behavior
    e.stopPropagation(); // Stop event bubbling

    var targetUrl = exitLink.getAttribute("href");
    if (!targetUrl) return;

    showExitModal(targetUrl);
  });

  // Handle confirm button click
  if (confirmBtn) {
    confirmBtn.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default anchor behavior
      e.stopPropagation(); // Stop event bubbling

      if (currentExitLink) {
        // Open the link in a new tab
        window.open(currentExitLink, "_blank", "noopener,noreferrer");
        hideExitModal();
      }
    });
  }

  // Handle cancel button click
  if (cancelBtn) {
    cancelBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      hideExitModal();
    });
  }

  // Handle clicking outside the modal or ESC key
  if (exitModal) {
    exitModal.addEventListener("click", function (e) {
      if (e.target === exitModal) {
        hideExitModal();
      }
    });

    exitModal.addEventListener("cancel", function (e) {
      hideExitModal();
    });
  }
})();


// Unified smooth scroll helper for anchors and register form
(function () {
  if (typeof document === "undefined") return;

  function mastheadOffsetForViewport() {
    var masthead = document.getElementById("masthead");
    if (!masthead) return 0;
    var hidden = document.body.classList.contains("masthead-scroll-hidden");
    if (!hidden) {
      var primary = masthead.querySelector(".site-header__primary");
      return primary ? primary.offsetHeight : masthead.offsetHeight;
    }
    var rail = masthead.querySelector(".site-header__minimized");
    return rail ? rail.offsetHeight : 0;
  }

  function getScrollOffset() {
    var offset = 0;
    var adminBar = document.getElementById("wpadminbar");
    if (adminBar && adminBar.offsetHeight) {
      offset += adminBar.offsetHeight;
    }
    offset += mastheadOffsetForViewport();
    // Always reserve sticky subnav height. The old "already stuck" check
    // (subnavRect.top ≈ 0) almost never matched because .subnav sticks at
    // top: 109px / 75px / 34px — so section H2s landed under the bar.
    var subnav = document.querySelector(".subnav");
    if (subnav) {
      var computedStyle = window.getComputedStyle(subnav);
      var isSticky =
        computedStyle.position === "sticky" ||
        computedStyle.position === "fixed";
      if (isSticky) {
        offset += subnav.offsetHeight;
      }
    }
    return offset;
  }

  var REGISTER_SCROLL_GAP = 20;

  function isRegisterLink(href) {
    if (!href) return false;
    if (isRegisterForUpdatesLink(href)) return false;
    if (href === "#register") return true;
    try {
      return new URL(href, window.location.href).hash === "#register";
    } catch (err) {
      return href.indexOf("#register") !== -1 && href.indexOf("#register-for-updates") === -1;
    }
  }

  function isRegisterForUpdatesLink(href) {
    if (!href) return false;
    if (href === "#register-for-updates") return true;
    try {
      return new URL(href, window.location.href).hash === "#register-for-updates";
    } catch (err) {
      return href.indexOf("#register-for-updates") !== -1;
    }
  }

  function isSamePageRegisterLink(href) {
    if (!isRegisterLink(href)) return false;
    if (href === "#register") return true;
    try {
      var url = new URL(href, window.location.href);
      return url.pathname === window.location.pathname;
    } catch (err) {
      return true;
    }
  }

  function isSamePageRegisterForUpdatesLink(href) {
    if (!isRegisterForUpdatesLink(href)) return false;
    if (href === "#register-for-updates") return true;
    try {
      var url = new URL(href, window.location.href);
      return url.pathname === window.location.pathname;
    } catch (err) {
      return true;
    }
  }

  function triggerRegisterForUpdatesAnchor(event) {
    if (typeof window.handleRegisterForUpdatesAnchor === "function") {
      window.handleRegisterForUpdatesAnchor(event);
      return;
    }

    sessionStorage.setItem("registerForUpdatesAnchor", "true");
    if (history.pushState) {
      history.pushState(null, null, "#register-for-updates");
    } else {
      window.location.hash = "register-for-updates";
    }
  }

  function prepareHeaderForRegisterScroll() {
    var masthead = document.getElementById("masthead");
    if (masthead) {
      masthead.classList.remove("site-header--scroll-hidden");
    }
    document.body.classList.remove("masthead-scroll-hidden");
  }

  function scrollToRegisterSection(options) {
    options = options || {};
    var registerSection = document.getElementById("register");
    if (!registerSection) return false;

    if (typeof window.closeTopNavMobileMenu === "function") {
      window.closeTopNavMobileMenu();
    }

    prepareHeaderForRegisterScroll();

    var target =
      registerSection.querySelector(".register-form__heading") || registerSection;
    var behavior =
      options.behavior ||
      (window.matchMedia("(max-width: 1100px)").matches ? "auto" : "smooth");

    function doScroll() {
      prepareHeaderForRegisterScroll();
      var offset = getScrollOffset() + REGISTER_SCROLL_GAP;
      var rect = target.getBoundingClientRect();
      var scrollTo = rect.top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, scrollTo), behavior: behavior });
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(doScroll);
    });

    return true;
  }

  function smoothScrollToElement(element) {
    if (!element) return;
    if (element.id === "register-for-updates") {
      triggerRegisterForUpdatesAnchor();
      return;
    }
    if (element.id === "register") {
      scrollToRegisterSection();
      return;
    }
    var offset = getScrollOffset();
    var rect = element.getBoundingClientRect();
    var scrollTo = rect.top + window.pageYOffset - offset;
    window.scrollTo({ top: scrollTo, behavior: "smooth" });
  }

  // Handle clicks on subnav links and any anchor links
  document.addEventListener("click", function (e) {
    var link = e.target.closest("a");
    if (!link) return;
    var href = link.getAttribute("href");
    if (!href) return;

    if (isSamePageRegisterForUpdatesLink(href)) {
      e.preventDefault();
      triggerRegisterForUpdatesAnchor(e);
      if (history.pushState) {
        history.pushState(null, null, "#register-for-updates");
      }
      return;
    }

    if (isSamePageRegisterLink(href)) {
      if (!document.getElementById("register")) return;
      e.preventDefault();
      scrollToRegisterSection();
      if (history.pushState) {
        history.pushState(null, null, "#register");
      }
      return;
    }

    if (!href.startsWith("#")) return;
    var targetId = href.substring(1);
    var target = document.getElementById(targetId);
    if (!target) return;
    e.preventDefault();
    smoothScrollToElement(target);
    // Update URL without triggering scroll
    if (history.pushState) {
      history.pushState(null, null, href);
    }
  });

  // Handle deeplinks on page load
  function handleDeeplink() {
    var hash = window.location.hash;
    if (!hash || hash.length <= 1) return;
    var targetId = hash.substring(1);
    if (targetId === "register-for-updates") {
      sessionStorage.setItem("registerForUpdatesAnchor", "true");
      return;
    }
    if (targetId === "register") {
      setTimeout(function () {
        scrollToRegisterSection({ behavior: "auto" });
      }, 100);
      return;
    }
    var target = document.getElementById(targetId);
    if (!target) return;
    setTimeout(function () {
      smoothScrollToElement(target);
    }, 100);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", handleDeeplink);
  } else {
    handleDeeplink();
  }

  // Expose for use in scrollToRegister
  window.smoothScrollToElement = smoothScrollToElement;
  window.scrollToRegisterSection = scrollToRegisterSection;

  // Highlight the subnav link for the section at/above the sticky header line
  function initSubnavScrollSpy() {
    var subnavEl = document.querySelector(".subnav");
    if (!subnavEl) return;
    var spyLinks = subnavEl.querySelectorAll("a.subnav-link[href^='#']");
    if (!spyLinks.length) return;

    function spyLineY() {
      var o = mastheadOffsetForViewport();
      o += subnavEl.offsetHeight;
      return o + 12;
    }

    function updateSubnavActive() {
      var scrollY = window.scrollY || window.pageYOffset;
      var line = scrollY + spyLineY();
      var currentId = null;
      for (var i = spyLinks.length - 1; i >= 0; i--) {
        var href = spyLinks[i].getAttribute("href");
        if (!href || href.length < 2) continue;
        var id = href.substring(1);
        var section = document.getElementById(id);
        if (!section) continue;
        if (section.offsetTop <= line) {
          currentId = id;
          break;
        }
      }
      // No fallback: leave all links inactive until a section top crosses the spy line
      for (var j = 0; j < spyLinks.length; j++) {
        var link = spyLinks[j];
        var h = link.getAttribute("href");
        var lid = h && h.length > 1 ? h.substring(1) : "";
        var on = lid === currentId;
        link.classList.toggle("active", on);
        if (on) link.setAttribute("aria-current", "location");
        else link.removeAttribute("aria-current");
      }
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateSubnavActive();
        ticking = false;
      });
    }

    function runWhenReady() {
      updateSubnavActive();
      window.addEventListener("scroll", onScrollOrResize, { passive: true });
      window.addEventListener("resize", onScrollOrResize);
      window.addEventListener("hashchange", updateSubnavActive);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", runWhenReady);
    } else {
      runWhenReady();
    }
  }
  initSubnavScrollSpy();
})();

// HCP Modal functionality
(function () {
  var hcpModal = document.getElementById("hcp-modal");
  var hcpYesBtn = document.getElementById("hcp-yes");
  var hcpNoBtn = document.getElementById("hcp-no");
  var cookieName = "hcp_modal_seen";

  // Cookie utility functions
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function showHCPModal() {
    if (hcpModal) {
      hcpModal.showModal();
    }
  }

  function hideHCPModal() {
    if (hcpModal) {
      hcpModal.close();
    }
  }

  // Check if user has seen the modal before
  function checkHCPModalStatus() {
    var hasSeenModal = getCookie(cookieName);
    if (!hasSeenModal) {
      // Show modal after a short delay to ensure page is loaded
      setTimeout(showHCPModal, 500);
    }
  }

  // Handle HCP Yes button click
  if (hcpYesBtn) {
    hcpYesBtn.addEventListener("click", function () {
      setCookie(cookieName, "yes", 365); // Set cookie for 1 year
      hideHCPModal();
    });
  }

  // Handle HCP No button click - redirect to patient site
  if (hcpNoBtn) {
    hcpNoBtn.addEventListener("click", function () {
      setCookie(cookieName, "no", 365); // Set cookie for 1 year
      // Replace with actual patient site URL
      window.location.href = "https://ascendispharma.us/";
    });
  }

  // Prevent modal from closing when clicking outside or pressing ESC
  if (hcpModal) {
    hcpModal.addEventListener("cancel", function (e) {
      e.preventDefault(); // Prevent default close behavior
    });

    hcpModal.addEventListener("click", function (e) {
      if (e.target === hcpModal) {
        e.preventDefault(); // Prevent closing when clicking backdrop
      }
    });
  }

  // Initialize modal check on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkHCPModalStatus);
  } else {
    checkHCPModalStatus();
  }
})();

// Track fullscreen state so the fixed site header / FDA banner / ISI preview
// can be hidden while a video (e.g. the H5P IFU video) is in fullscreen.
// Covers native Fullscreen API (incl. WebKit prefix) and H5P's semi-fullscreen fallback.
(function () {
  if (typeof document === "undefined") return;

  function isInFullscreen() {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      return true;
    }
    if (document.body.classList.contains("h5p-semi-fullscreen")) return true;
    if (document.querySelector(".h5p-content.h5p-fullscreen, .h5p-content.h5p-semi-fullscreen")) {
      return true;
    }
    return false;
  }

  function syncFullscreenClass() {
    document.body.classList.toggle("is-fullscreen", isInFullscreen());
  }

  document.addEventListener("fullscreenchange", syncFullscreenClass);
  document.addEventListener("webkitfullscreenchange", syncFullscreenClass);
  document.addEventListener("msfullscreenchange", syncFullscreenClass);

  if (typeof MutationObserver !== "undefined") {
    var mo = new MutationObserver(syncFullscreenClass);
    mo.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
    });
  }

  syncFullscreenClass();
})();

// Hide header on scroll down, show on scroll up (fixed header + spacer layout)
(function () {
  if (typeof document === "undefined" || !window.addEventListener) return;

  function initHeaderScrollBehavior() {
    var masthead = document.getElementById("masthead");
    var spacer = document.querySelector(".site-header-spacer");
    if (!masthead || !spacer) return;

    var lastScrollY = window.scrollY || window.pageYOffset;
    var ticking = false;
    var primary = masthead.querySelector(".site-header__primary");
    var rail = masthead.querySelector(".site-header__minimized");
    /**
     * Distance-based hysteresis (avoids flip-flop from small deltas + scroll anchoring when
     * spacer / sticky subnav reflow). Only change masthead state after meaningful movement
     * from the scroll position where we last expanded or collapsed.
     */
    var headerScrollAnchorY = lastScrollY;
    var HEADER_COLLAPSE_MIN_DOWN = 56;
    var HEADER_EXPAND_MIN_UP = 40;
    var HEADER_SCROLL_INTENT_PX = 5;
    var spacerResizeRaf = null;

    function shouldUseMinimizedRail() {
      return !!rail;
    }

    function setSpacerHeight() {
      var scrollHidden = masthead.classList.contains(
        "site-header--scroll-hidden",
      );
      var h;
      if (scrollHidden && shouldUseMinimizedRail()) {
        h = rail.offsetHeight || 36;
      } else if (primary) {
        h = primary.offsetHeight;
      } else {
        h = masthead.offsetHeight;
      }
      spacer.style.height = h + "px";
    }

    function scheduleSetSpacerHeight() {
      if (spacerResizeRaf !== null) return;
      spacerResizeRaf = window.requestAnimationFrame(function () {
        spacerResizeRaf = null;
        setSpacerHeight();
      });
    }

    function syncHeaderNavAccessibility() {
      if (!primary || !rail) return;
      var menuOpen = document.body.classList.contains("mobile-menu-open");
      var scrollHidden = masthead.classList.contains(
        "site-header--scroll-hidden",
      );
      var showRail = shouldUseMinimizedRail() && scrollHidden && !menuOpen;

      if (showRail) {
        primary.setAttribute("aria-hidden", "true");
        rail.setAttribute("aria-hidden", "false");
        primary.setAttribute("inert", "");
        rail.removeAttribute("inert");
      } else {
        primary.setAttribute("aria-hidden", "false");
        rail.setAttribute("aria-hidden", "true");
        primary.removeAttribute("inert");
        rail.setAttribute("inert", "");
      }
    }

    function syncMastheadHiddenState() {
      var menuOpen = document.body.classList.contains("mobile-menu-open");
      var scrollHidden = masthead.classList.contains(
        "site-header--scroll-hidden",
      );
      document.body.classList.toggle(
        "masthead-scroll-hidden",
        scrollHidden && !menuOpen,
      );
    }

    function handleScroll() {
      var y = window.scrollY || window.pageYOffset;

      if (document.body.classList.contains("mobile-menu-open")) {
        masthead.classList.remove("site-header--scroll-hidden");
        lastScrollY = y;
        headerScrollAnchorY = y;
        syncMastheadHiddenState();
        setSpacerHeight();
        syncHeaderNavAccessibility();
        return;
      }

      var delta = y - lastScrollY;
      lastScrollY = y;

      var hidden = masthead.classList.contains("site-header--scroll-hidden");

      if (y < 40) {
        masthead.classList.remove("site-header--scroll-hidden");
        headerScrollAnchorY = y;
      } else if (!hidden) {
        if (
          delta > HEADER_SCROLL_INTENT_PX &&
          y >= headerScrollAnchorY + HEADER_COLLAPSE_MIN_DOWN
        ) {
          masthead.classList.add("site-header--scroll-hidden");
          headerScrollAnchorY = y;
        }
      } else {
        if (
          delta < -HEADER_SCROLL_INTENT_PX &&
          y <= headerScrollAnchorY - HEADER_EXPAND_MIN_UP
        ) {
          masthead.classList.remove("site-header--scroll-hidden");
          headerScrollAnchorY = y;
        }
      }

      syncMastheadHiddenState();
      setSpacerHeight();
      syncHeaderNavAccessibility();
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    function onLayoutOrLayerChange() {
      syncMastheadHiddenState();
      scheduleSetSpacerHeight();
      syncHeaderNavAccessibility();
    }

    syncMastheadHiddenState();
    setSpacerHeight();
    syncHeaderNavAccessibility();

    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(scheduleSetSpacerHeight);
      if (primary) ro.observe(primary);
      if (rail) ro.observe(rail);
    }
    window.addEventListener("resize", onLayoutOrLayerChange);

    if (window.matchMedia) {
      var mq = window.matchMedia("(min-width: 1101px)");
      var onMq = function () {
        scheduleSetSpacerHeight();
        syncHeaderNavAccessibility();
      };
      if (mq.addEventListener) {
        mq.addEventListener("change", onMq);
      } else if (mq.addListener) {
        mq.addListener(onMq);
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });

    if (typeof MutationObserver !== "undefined") {
      var mo = new MutationObserver(onLayoutOrLayerChange);
      mo.observe(masthead, { attributes: true, attributeFilter: ["class"] });
      mo.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaderScrollBehavior);
  } else {
    initHeaderScrollBehavior();
  }
})();

// Top Navigation Burger Menu Toggle
(function () {
  function initTopNavMenu() {
    var menuToggles = document.querySelectorAll(".mobile-menu-toggle");
    var mobileMenuPanel = document.getElementById("mobile-menu-panel");

    function isMenuExpanded() {
      for (var i = 0; i < menuToggles.length; i++) {
        if (menuToggles[i].getAttribute("aria-expanded") === "true") {
          return true;
        }
      }
      return false;
    }

    function setMobileMenuTop() {
      try {
        var docEl = document.documentElement;
        var baseTop = 0;
        var masthead = document.getElementById("masthead");
        var useMinimizedRail =
          window.innerWidth <= 1100 &&
          document.body.classList.contains("masthead-scroll-hidden") &&
          masthead;
        var rail = useMinimizedRail
          ? masthead.querySelector(".site-header__minimized")
          : null;

        if (rail) {
          baseTop = rail.getBoundingClientRect().bottom;
        } else {
          var nav = document.querySelector(".nav-main-row");
          if (nav) {
            baseTop = nav.getBoundingClientRect().bottom;
          } else {
            var fdaContent = document.querySelector(".fda-banner__content");
            if (fdaContent) {
              baseTop = fdaContent.getBoundingClientRect().bottom;
            } else {
              var fda = document.querySelector(".fda-banner");
              if (fda) {
                baseTop = fda.getBoundingClientRect().bottom;
              }
            }
          }
        }
        docEl.style.setProperty("--mobile-menu-top", baseTop + "px");
      } catch (e) {
        // ignore
      }
    }

    function closeAllMobileAccordions(exceptTrigger) {
      if (!mobileMenuPanel) return;
      mobileMenuPanel
        .querySelectorAll(".mobile-accordion-trigger[aria-expanded='true']")
        .forEach(function (trigger) {
          if (exceptTrigger && trigger === exceptTrigger) return;
          trigger.setAttribute("aria-expanded", "false");
          var panelId = trigger.getAttribute("aria-controls");
          if (!panelId) return;
          var panel = document.getElementById(panelId);
          if (panel) panel.hidden = true;
          var group = trigger.closest(
            ".mobile-menu-main__group, .mobile-menu-utility__accordion",
          );
          if (group) group.classList.remove("open");
        });
    }

    function closeMenuState() {
      menuToggles.forEach(function (toggle) {
        toggle.setAttribute("aria-expanded", "false");
        toggle.classList.remove("active");
      });
      if (mobileMenuPanel) {
        mobileMenuPanel.classList.remove("active");
        mobileMenuPanel.setAttribute("aria-hidden", "true");
      }
      document.body.classList.remove("mobile-menu-open");
      closeAllMobileAccordions();
    }

    window.closeTopNavMobileMenu = closeMenuState;

    function toggleMenu(e) {
      e.preventDefault();
      e.stopPropagation();

      if (isMenuExpanded()) {
        closeMenuState();
        return;
      }

      setMobileMenuTop();

      menuToggles.forEach(function (toggle) {
        toggle.setAttribute("aria-expanded", "true");
        toggle.classList.add("active");
      });
      if (mobileMenuPanel) {
        mobileMenuPanel.classList.add("active");
        mobileMenuPanel.setAttribute("aria-hidden", "false");
      }
      document.body.classList.add("mobile-menu-open");
    }

    if (menuToggles.length && mobileMenuPanel) {
      menuToggles.forEach(function (toggle) {
        toggle.addEventListener("click", toggleMenu);
      });
    }

    if (mobileMenuPanel) {
      mobileMenuPanel.addEventListener("click", function (e) {
        var trigger =
          e.target.closest &&
          e.target.closest(".mobile-accordion-trigger");
        if (!trigger || !mobileMenuPanel.contains(trigger)) return;
        e.preventDefault();
        e.stopPropagation();

        var panelId = trigger.getAttribute("aria-controls");
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        var isOpen = trigger.getAttribute("aria-expanded") === "true";
        closeAllMobileAccordions();

        if (!isOpen) {
          trigger.setAttribute("aria-expanded", "true");
          panel.hidden = false;
          var group = trigger.closest(
            ".mobile-menu-main__group, .mobile-menu-utility__accordion",
          );
          if (group) group.classList.add("open");
        }

        setMobileMenuTop();
      });
    }

    document.addEventListener("click", function (e) {
      if (
        !e.target.closest(".nav-main-row") &&
        !e.target.closest(".site-header__minimized") &&
        !e.target.closest(".mobile-menu-panel")
      ) {
        closeMenuState();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeMenuState();
      }
    });

    window.addEventListener("scroll", function () {
      if (
        mobileMenuPanel &&
        mobileMenuPanel.classList.contains("active")
      ) {
        setMobileMenuTop();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 1100) {
        closeMenuState();
        return;
      }
      if (
        mobileMenuPanel &&
        mobileMenuPanel.classList.contains("active")
      ) {
        setMobileMenuTop();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTopNavMenu);
  } else {
    initTopNavMenu();
  }
})();

// Registration Form Custom Validation
(function () {
  function initFormValidation() {
    var form = document.querySelector(".register-form");

    if (!form) return;

    // Disable HTML5 validation to use custom messages
    form.setAttribute("novalidate", "novalidate");

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var isValid = true;

      // Get all required input fields
      var requiredFields = form.querySelectorAll("input[required]");

      // Clear all previous error messages
      var allErrors = form.querySelectorAll(".error-message");
      allErrors.forEach(function (error) {
        error.classList.remove("show");
      });

      // Validate each required field
      requiredFields.forEach(function (field) {
        var value = field.value.trim();
        var errorMessage = field.parentElement.querySelector(".error-message");

        if (!value) {
          isValid = false;
          if (errorMessage) {
            errorMessage.classList.add("show");
          }
          field.setAttribute("aria-invalid", "true");
        } else {
          // Email validation for email fields
          if (field.type === "email") {
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
              isValid = false;
              if (errorMessage) {
                errorMessage.textContent = "A valid email is required";
                errorMessage.classList.add("show");
              }
              field.setAttribute("aria-invalid", "true");
            } else {
              field.setAttribute("aria-invalid", "false");
            }
          }
          // ZIP code validation for zip field
          else if (field.name === "zip") {
            var zipRegex = /^\d{5}$/;
            if (!zipRegex.test(value)) {
              isValid = false;
              if (errorMessage) {
                errorMessage.textContent =
                  "Please enter a valid 5-digit US ZIP code";
                errorMessage.classList.add("show");
              }
              field.setAttribute("aria-invalid", "true");
            } else {
              field.setAttribute("aria-invalid", "false");
            }
          }
          // Name validation for first_name and last_name fields (no numbers)
          else if (field.name === "first_name" || field.name === "last_name") {
            var nameRegex = /^[^0-9]+$/;
            if (!nameRegex.test(value)) {
              isValid = false;
              if (errorMessage) {
                errorMessage.textContent = "Name cannot contain numbers";
                errorMessage.classList.add("show");
              }
              field.setAttribute("aria-invalid", "true");
            } else {
              field.setAttribute("aria-invalid", "false");
            }
          } else {
            field.setAttribute("aria-invalid", "false");
          }
        }
      });

      // Check radio buttons
      var radioGroup = form.querySelector('input[name="description"]');
      if (radioGroup) {
        var radioChecked = form.querySelector(
          'input[name="description"]:checked',
        );
        var radioError = form.querySelector(".radio-error");

        if (!radioChecked) {
          isValid = false;
          if (radioError) {
            radioError.classList.add("show");
          }
        } else if (radioError) {
          radioError.classList.remove("show");
        }
      }

      // Check checkboxes
      var privacyCheckbox = form.querySelector('input[name="privacy_consent"]');
      var dataCheckbox = form.querySelector('input[name="data_consent"]');

      if (privacyCheckbox) {
        var privacyError = privacyCheckbox
          .closest(".checkbox-field")
          .querySelector(".checkbox-error");
        if (!privacyCheckbox.checked) {
          isValid = false;
          if (privacyError) {
            privacyError.classList.add("show");
          }
        } else if (privacyError) {
          privacyError.classList.remove("show");
        }
      }

      if (dataCheckbox) {
        var dataError = dataCheckbox
          .closest(".checkbox-field")
          .querySelector(".checkbox-error");
        if (!dataCheckbox.checked) {
          isValid = false;
          if (dataError) {
            dataError.classList.add("show");
          }
        } else if (dataError) {
          dataError.classList.remove("show");
        }
      }

      // If form is valid, submit to external handler
      if (isValid) {
        // Disable submit button to prevent double submission
        var submitBtn = form.querySelector(".form-submit-btn");
        var originalBtnText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = "...";

        // Collect form data
        var formData = new FormData(form);
        var submitUrl =
          "https://cloud.communications.ascendispharma.com/yuviwelcaregiverbrandedreghandler";

        // Submit via fetch (AJAX)
        fetch(submitUrl, {
          method: "POST",
          body: formData,
          mode: "no-cors", // Required for cross-origin requests without CORS
        })
          .then(function (response) {
            // With no-cors mode, we can't read the response, but we assume success
            // Show thank you message
            var container = form.closest(".register-form-container");
            var thankYouDiv = container.querySelector(
              ".register-form-thank-you",
            );

            // Hide the form
            form.style.display = "none";

            // Hide the original heading and subtext (the ones before the thank you div)
            var allHeadings = container.querySelectorAll(
              ".register-form__heading",
            );
            var allSubtexts = container.querySelectorAll(
              ".register-form__subtext",
            );

            // Hide the first heading and subtext (the original ones)
            if (allHeadings.length > 0) {
              allHeadings[0].style.display = "none";
            }
            if (allSubtexts.length > 0) {
              allSubtexts[0].style.display = "none";
            }

            // Show thank you message
            if (thankYouDiv) {
              thankYouDiv.style.display = "block";
              // Smooth scroll to the thank you section
              setTimeout(function () {
                thankYouDiv.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }, 100);
            }
          })
          .catch(function (error) {
            // On error, re-enable button and show error message
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;

            // Show a generic error message
            alert("There was an error submitting your form. Please try again.");
            console.error("Form submission error:", error);
          });
      } else {
        // Scroll to first error
        var firstError = form.querySelector(".error-message.show");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });

    // Hide error message when user starts typing
    var inputs = form.querySelectorAll("input[required]");
    inputs.forEach(function (input) {
      input.addEventListener("input", function () {
        var errorMessage = this.parentElement.querySelector(".error-message");
        if (errorMessage && this.value.trim()) {
          errorMessage.classList.remove("show");
          this.setAttribute("aria-invalid", "false");
        }
      });

      // Real-time email validation on blur
      if (input.type === "email") {
        input.addEventListener("blur", function () {
          var value = this.value.trim();
          var errorMessage = this.parentElement.querySelector(".error-message");
          if (value) {
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
              if (errorMessage) {
                errorMessage.textContent = "A valid email is required";
                errorMessage.classList.add("show");
              }
              this.setAttribute("aria-invalid", "true");
            } else {
              if (errorMessage) {
                errorMessage.classList.remove("show");
              }
              this.setAttribute("aria-invalid", "false");
            }
          }
        });
      }

      // Real-time ZIP code validation and numeric-only input
      if (input.name === "zip") {
        // Filter out non-numeric characters as user types
        input.addEventListener("input", function () {
          // Remove any non-numeric characters
          this.value = this.value.replace(/\D/g, "");
          // Ensure maxlength is enforced (already set in HTML, but enforce here too)
          if (this.value.length > 5) {
            this.value = this.value.slice(0, 5);
          }
        });

        // Prevent non-numeric characters from being pasted
        input.addEventListener("paste", function (e) {
          e.preventDefault();
          var pastedText = (e.clipboardData || window.clipboardData).getData(
            "text",
          );
          var numericOnly = pastedText.replace(/\D/g, "").slice(0, 5);
          this.value = numericOnly;
        });

        input.addEventListener("blur", function () {
          var value = this.value.trim();
          var errorMessage = this.parentElement.querySelector(".error-message");
          if (value) {
            var zipRegex = /^\d{5}$/;
            if (!zipRegex.test(value)) {
              if (errorMessage) {
                errorMessage.textContent =
                  "Please enter a valid 5-digit US ZIP code";
                errorMessage.classList.add("show");
              }
              this.setAttribute("aria-invalid", "true");
            } else {
              if (errorMessage) {
                errorMessage.classList.remove("show");
              }
              this.setAttribute("aria-invalid", "false");
            }
          }
        });
      }

      // Real-time name validation on blur (no numbers)
      if (input.name === "first_name" || input.name === "last_name") {
        input.addEventListener("blur", function () {
          var value = this.value.trim();
          var errorMessage = this.parentElement.querySelector(".error-message");
          if (value) {
            var nameRegex = /^[^0-9]+$/;
            if (!nameRegex.test(value)) {
              if (errorMessage) {
                errorMessage.textContent = "Name cannot contain numbers";
                errorMessage.classList.add("show");
              }
              this.setAttribute("aria-invalid", "true");
            } else {
              if (errorMessage) {
                errorMessage.classList.remove("show");
              }
              this.setAttribute("aria-invalid", "false");
            }
          }
        });
      }
    });

    // Hide radio button error when a selection is made
    var radioButtons = form.querySelectorAll('input[name="description"]');
    radioButtons.forEach(function (radio) {
      radio.addEventListener("change", function () {
        var radioError = form.querySelector(".radio-error");
        if (radioError) {
          radioError.classList.remove("show");
        }
      });
    });

    // Hide checkbox errors when checkboxes are checked
    var checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        var checkboxError =
          this.closest(".checkbox-field").querySelector(".checkbox-error");
        if (checkboxError && this.checked) {
          checkboxError.classList.remove("show");
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFormValidation);
  } else {
    initFormValidation();
  }
})();

// ISI Expand Button Functionality
(function () {
  function initISIExpand() {
    var isiExpandBtn = document.querySelector(".isi-expand");
    var isiSection = document.getElementById("isi");
    var isiPreview = document.getElementById("isi_preview");
    var isiExpandBtns = isiPreview
      ? isiPreview.querySelectorAll(".isi-expand")
      : [];
    var isiPreviewAccordion = isiPreview
      ? isiPreview.querySelector(".isi-preview-accordion")
      : null;
    var isiPreviewAccordionToggle = isiPreview
      ? isiPreview.querySelector(".isi-preview-accordion__toggle")
      : null;
    var homeHeroContainer = document.querySelector(".home-hero-section__container");
    var heroSection = document.querySelector(".hero-section");
    var fallbackAutoCollapseThreshold = 75;
    var didAutoCollapseAccordion = false;
    var accordionClickHandler = null;
    var registerForm = document.querySelector(".register-form");
    var isRegisterFormInputFocused = false;
    var registerFormFocusTimeout = null;

    function isIsiMobileViewport() {
      return window.innerWidth <= 900;
    }

    function hidePreviewForFormFocus() {
      isiPreview.style.display = "none";
    }

    function initRegisterFormPreviewFocusHandlers() {
      if (!registerForm) {
        return;
      }

      registerForm.addEventListener("focusin", function (e) {
        if (!isIsiMobileViewport() || !e.target.matches("input, textarea, select")) {
          return;
        }

        clearTimeout(registerFormFocusTimeout);
        isRegisterFormInputFocused = true;
        hidePreviewForFormFocus();
      });

      registerForm.addEventListener("focusout", function (e) {
        if (!isIsiMobileViewport() || !e.target.matches("input, textarea, select")) {
          return;
        }

        clearTimeout(registerFormFocusTimeout);
        registerFormFocusTimeout = setTimeout(function () {
          if (registerForm.contains(document.activeElement)) {
            return;
          }

          isRegisterFormInputFocused = false;
          handleScroll();
        }, 100);
      });
    }

    if (!isiExpandBtns.length || !isiSection || !isiPreview) {
      console.warn("ISI expand button, section, or preview not found");
      return;
    }

    function setPreviewAccordionExpanded(isExpanded, wasAutoCollapsed) {
      if (!isiPreviewAccordion || !isiPreviewAccordionToggle) {
        return;
      }

      isiPreviewAccordion.classList.toggle("is-collapsed", !isExpanded);
      isiPreviewAccordionToggle.setAttribute(
        "aria-expanded",
        isExpanded ? "true" : "false",
      );

      if (wasAutoCollapsed) {
        isiPreviewAccordion.setAttribute("data-auto-collapsed", "true");
      }
    }

    function detachAccordionMobileListeners() {
      if (!accordionClickHandler || !isiPreviewAccordionToggle) {
        return;
      }
      isiPreviewAccordionToggle.removeEventListener(
        "click",
        accordionClickHandler,
      );
      accordionClickHandler = null;
      didAutoCollapseAccordion = false;
    }

    function attachAccordionMobileListeners() {
      if (
        !isIsiMobileViewport() ||
        !isiPreviewAccordion ||
        !isiPreviewAccordionToggle ||
        accordionClickHandler
      ) {
        return;
      }

      setPreviewAccordionExpanded(true, false);

      accordionClickHandler = function () {
        var isExpanded =
          isiPreviewAccordionToggle.getAttribute("aria-expanded") === "true";
        setPreviewAccordionExpanded(!isExpanded, false);
      };
      isiPreviewAccordionToggle.addEventListener(
        "click",
        accordionClickHandler,
      );
    }

    if (isIsiMobileViewport()) {
      attachAccordionMobileListeners();
    }

    function setAllExpandAriaExpanded(value) {
      isiExpandBtns.forEach(function (btn) {
        btn.setAttribute("aria-expanded", value);
      });
    }

    // Add click event listener
    isiExpandBtns.forEach(function (isiExpandBtn) {
      isiExpandBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Hide the preview bar
        isiPreview.style.display = "none";

        // Align #isi below sticky header (same offset as in-page #anchors; see getScrollOffset)
        if (typeof window.smoothScrollToElement === "function") {
          window.smoothScrollToElement(isiSection);
        } else {
          var offset = 100;
          var targetPosition =
            isiSection.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }

        setAllExpandAriaExpanded("true");
      });
    });

    // Scroll handler to show/hide preview based on ISI visibility
    function handleScroll() {
      var isiRect = isiSection.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      var hasScrolledPastHero = homeHeroContainer
        ? homeHeroContainer.getBoundingClientRect().bottom <= 0
        : heroSection
          ? heroSection.getBoundingClientRect().bottom <= 0
          : window.scrollY > fallbackAutoCollapseThreshold;

      // Check if we're on mobile (width <= 900px)
      var isMobile = window.innerWidth <= 900;

      // On mobile, account for the 100px bottom offset of the preview
      var mobileOffset = isMobile ? 100 : 0;

      // Check if ISI section is visible in viewport
      // ISI is considered visible when its top is in the viewport (accounting for mobile offset)
      if (isiRect.top < windowHeight - mobileOffset && isiRect.bottom > 0) {
        // ISI is visible, hide preview
        isiPreview.style.display = "none";
      } else if (isiRect.top >= windowHeight - mobileOffset) {
        // Keep preview hidden while typing in the registration form (iOS Safari fixed-position bug)
        if (isMobile && isRegisterFormInputFocused) {
          hidePreviewForFormFocus();
          return;
        }

        // ISI is below viewport, show preview and button
        isiPreview.style.display = "block";
        isiPreview.style.visibility = "visible";

        // Force expand controls visible
        isiExpandBtns.forEach(function (btn) {
          btn.style.display = "block";
          btn.style.visibility = "visible";
          btn.style.opacity = "1";
          btn.style.pointerEvents = "all";
        });

        // Reset aria-expanded
        setAllExpandAriaExpanded("false");
      }

      if (
        isIsiMobileViewport() &&
        !didAutoCollapseAccordion &&
        isiPreviewAccordion &&
        hasScrolledPastHero
      ) {
        setPreviewAccordionExpanded(false, true);
        didAutoCollapseAccordion = true;
      }
    }

    // Throttle scroll events for performance
    var scrollTimeout;
    window.addEventListener("scroll", function () {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(handleScroll, 10);
    });

    var resizeTimeout;
    window.addEventListener("resize", function () {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(function () {
        if (isIsiMobileViewport()) {
          didAutoCollapseAccordion = false;
          attachAccordionMobileListeners();
          setPreviewAccordionExpanded(true, false);
          handleScroll();
        } else {
          detachAccordionMobileListeners();
        }
      }, 150);
    });

    initRegisterFormPreviewFocusHandlers();

    // Initial check on page load
    handleScroll();
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initISIExpand);
  } else {
    initISIExpand();
  }
})();

// Thank You Page - Sign Up Again functionality
(function () {
  function initThankYouPage() {
    var signUpAgainBtn = document.getElementById("sign-up-again");
    var headerSignUpBtns = document.querySelectorAll(
      ".signup-button, .btn--yellow, a[href='/sign-up'], a[href='#register'], a[href='/sign-up#rep']",
    );

    if (signUpAgainBtn) {
      signUpAgainBtn.addEventListener("click", function (e) {
        e.preventDefault();
        sessionStorage.setItem("clearRegistrationForm", "true");
        window.location.href = "/#register";
      });
    }

    if (headerSignUpBtns && headerSignUpBtns.length) {
      headerSignUpBtns.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          var onThankYou = window.location.pathname.indexOf("thank-you") !== -1;
          var registerForm = document.querySelector(".register-form");
          if (onThankYou) {
            e.preventDefault();
            sessionStorage.setItem("clearRegistrationForm", "true");
            window.location.href = "/#register";
            return;
          }
          if (btn.tagName === "A") {
            btn.setAttribute("href", "#register");
          }
          if (!registerForm) {
            e.preventDefault();
            sessionStorage.setItem("animateToRegister", "true");
            window.location.href = "/#register";
          }
        });
      });
    }
  (function () {
    // On page load, if animateToRegister is set, scroll to #register
    if (sessionStorage.getItem("animateToRegister") === "true") {
      var scrollToRegister = function () {
        if (typeof window.scrollToRegisterSection === "function") {
          window.scrollToRegisterSection({ behavior: "auto" });
          sessionStorage.removeItem("animateToRegister");
        }
      };
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", scrollToRegister);
      } else {
        scrollToRegister();
      }
    }
  })();
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initThankYouPage);
  } else {
    initThankYouPage();
  }
})();

// Clear registration form if coming from thank you page
(function () {
  function checkAndClearForm() {
    var shouldClear = sessionStorage.getItem("clearRegistrationForm");

    if (shouldClear === "true") {
      var form = document.querySelector(".register-form");

      if (form) {
        // Clear all input fields
        var inputs = form.querySelectorAll(
          "input[type='text'], input[type='email']",
        );
        inputs.forEach(function (input) {
          input.value = "";
        });

        // Uncheck all radio buttons
        var radios = form.querySelectorAll("input[type='radio']");
        radios.forEach(function (radio) {
          radio.checked = false;
        });

        // Uncheck all checkboxes
        var checkboxes = form.querySelectorAll("input[type='checkbox']");
        checkboxes.forEach(function (checkbox) {
          checkbox.checked = false;
        });

        // Clear the flag
        sessionStorage.removeItem("clearRegistrationForm");

        console.log("Registration form cleared");
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkAndClearForm);
  } else {
    checkAndClearForm();
  }
})();
